import React from 'react';

const GRID_BG: Record<string, string | undefined> = {
  math_5mm: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M 20 0 L 0 0 0 20' fill='none' stroke='%23e2e8f0' stroke-width='1'/%3E%3C/svg%3E")`,
  dot_grid: `radial-gradient(circle, #cbd5e1 1px, transparent 1px)`,
  blank: undefined,
};

export function PrintMathWorkspace({
  gridType = 'math_5mm',
  heightRows = 8,
  showResultLine = true,
}: {
  gridType?: 'math_5mm' | 'dot_grid' | 'blank';
  heightRows?: number;
  showResultLine?: boolean;
}) {
  const gridBackground = GRID_BG[gridType];
  const gridSize = gridType === 'dot_grid' ? '12px 12px' : undefined;

  return (
    <div className="print-sim-matrix__workspace print-math-workspace">
      <span className="print-sim-matrix__workspace-label">Espacio de cálculos:</span>
      <div
        className="print-sim-matrix__workspace-area"
        style={{
          height: `${heightRows * 24}px`,
          backgroundImage: gridBackground,
          backgroundSize: gridSize,
        }}
        aria-hidden
      />
      {showResultLine ? (
        <>
          <p className="print-instruction print-instruction--result">Resultado:</p>
          <div className="print-writing-lines print-math-workspace__result" aria-hidden>
            <div className="print-writing-line" />
          </div>
        </>
      ) : null}
    </div>
  );
}
